import downloaderActions from "@cirrus/legacy/app-author/alt/application/application/children/downloader/actions/downloaderActions.es6"

import { httpRequest, endpoint } from "@cirrus/core/http"

export const download = async (url, fileName) =>
  await downloaderActions.download(
    endpoint.withToken(`/api/v1/files/temp/download`, { url, fileName }),
  )
